import React from 'react';

import { EventType } from '../../../services/web-trackers-service/web-tracker-service';
import { Effect } from '../../../utils/function.utils';
import {
	StyledCarouselCardActions,
	StyledCarouselCardButton,
	StyledCarouselCardContent,
	StyledCarouselCardRoot,
} from './carousel-card.styles';

type CarouselCardProps = {
	actionLabel?: string;
	onAction?: Effect<EventType>;
	children: React.ReactNode;
	classes?: string;
};
export const CarouselCard = ({ actionLabel, children, onAction, classes }: CarouselCardProps) => (
	<StyledCarouselCardRoot tabIndex={0} role={'list'} className={`card-container ${classes ?? ''}`}>
		<StyledCarouselCardContent>{children}</StyledCarouselCardContent>
		{onAction && (
			<StyledCarouselCardActions>
				<StyledCarouselCardButton
					color={'primary'}
					onClick={onAction}
					data-testing-label={'carousel-card-main-action'}>
					{actionLabel}
				</StyledCarouselCardButton>
			</StyledCarouselCardActions>
		)}
	</StyledCarouselCardRoot>
);
